export enum SpinnerSize {
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl'
}

export type SpinnerSizeType = `${SpinnerSize}`;

export type SpinnerProps = React.HTMLAttributes<HTMLDivElement> & {
  spinning?: boolean;
  children?: React.ReactNode;
  delay?: number;
  size?: SpinnerSizeType;
  tip?: React.ReactNode;
  showBackgroundCircle?: boolean;
  showOverlayBlur?: boolean;
  overlayClassName?: string;
  centered?: boolean;
};
